import React, { useMemo } from 'react';
import { routes } from 'constants/config';
import thumbsUpIcon from 'images/thumbs_up.svg';
import thumbsDownIcon from 'images/thumbs_down.svg';
import xIcon from 'images/remove.svg';
import checkIcon from 'images/saved.svg';
import FilteredRequest from '../_shared/FilteredRequest';

function useThumbsIcons() {
  return [
    useMemo(() => (I18n.locale === 'ar' ? xIcon : thumbsUpIcon), []),
    useMemo(() => (I18n.locale === 'ar' ? checkIcon : thumbsDownIcon), []),
  ];
}

const RatingsCounts = ({ i18n }) => {
  const [thumbsUp, thumbsDown] = useThumbsIcons();
  return (
    <FilteredRequest url={routes.INSIGHTS.RATINGS.COUNTS}>
      {({ data, error }) =>
        !error && (
          <div>
            <div className="DataCard-count">
              <img
                src={thumbsUp}
                alt={`${i18n.ratings.lesson_ratings.total_likes}:`}
              />
              {data ? data.likes_count.toLocaleString(I18n.locale) : '…'}
            </div>
            <div className="DataCard-count">
              <img
                src={thumbsDown}
                alt={`${i18n.ratings.lesson_ratings.total_dislikes}:`}
              />
              {data ? data.dislikes_count.toLocaleString(I18n.locale) : '…'}
            </div>
          </div>
        )
      }
    </FilteredRequest>
  );
};

export default RatingsCounts;
